<template>
  <div class="modules">
    <div v-if="!isLoadedRotation && isLoadedDro">
      <loader class="table-loader" messages="home.labels.loading_message_table"></loader>
    </div>

    <div class="modules-list">
      <dro-module-item v-on:isLoaded="setLoadedDro" v-on:hasAccess="setHasAccessDro" :clientId="clientId"></dro-module-item>

      <rotation-module-item v-on:isLoaded="setLoadedRotation" v-on:hasAccess="setHasAccessRotation" :clientId="clientId"></rotation-module-item>
    </div>

    <div class="text-center" v-if="!hasAccessDro && !hasAccessRotation && isLoadedRotation && isLoadedDro">
      <h5>{{'dro.no_data' | trans }}</h5>
    </div>
  </div>
</template>

<script>
  import DroModuleItem from '../../../dro/components/ModuleItem.vue';
  import RotationModuleItem from '../../../randomRotation/components/ModuleItem.vue';
  import Loader from '../../../loader/components/Loader';
  import {mapState} from 'vuex';


  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return this.route.params.clientId || null;
        },
      },
    },

    data() {
      return {
        isLoadedDro: false,
        isLoadedRotation: false,
        hasAccessDro: false,
        hasAccessRotation: false
      }
    },

    components: {
      Loader, DroModuleItem, RotationModuleItem
    },

    computed: {
      ...mapState(['route'])
    },

    methods: {
      setHasAccessDro() {
        this.hasAccessDro = true;
      },
      setHasAccessRotation() {
        this.hasAccessRotation = true;
      },
      setLoadedDro() {
        this.isLoadedDro = true;
      },
      setLoadedRotation() {
        this.isLoadedRotation = true;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/user/client/components/ModulesList.vue